import "./phaser.min.js";
import Ui from "./Scenes/Ui.js";
import GameScene from "./Scenes/GameScene.js";
import Start from "./Scenes/Start.js";
import BackgroundManager from "./Scenes/BackgroundManager";
import DebugScene from "./Scenes/DebugScene";

const config = {
    type: Phaser.AUTO,        // or Phaser.WEBGL (preferred for performance)
    width: 480 * 4,
    height: 270 * 4,
    parent: 'game',
    backgroundColor: '#000000',
    scale: {
        mode: Phaser.Scale.FIT,      // or Phaser.Scale.NONE if you handle it manually
        autoCenter: Phaser.Scale.CENTER_BOTH,
        // zoom can be added for fixed integer scaling (e.g. zoom: 2)
    },
    physics: {
        default: 'arcade', // 👈 This must be defined
        arcade: {
            gravity: { y: 300 },
            debug: false
        }
    },
    scene: [
        GameScene,
        BackgroundManager,
        Start,
        Ui,
        DebugScene
    ],
    // ← This is critical for pixel art
    pixelArt: true,      // Enables nearest-neighbor filtering + sets roundPixels + disables antialias
    antialias: false,
    antialiasGL: false,
    roundPixels: true,   // Important for crisp camera movement and scrolling
    resolution: window.devicePixelRatio || 1,
    dom: { createContainer: true }
};
function startGame(config) {
    //clearInterval(fontCheck)
    let loader = document.getElementById('loader')
    loader.style.display = "none"
    new Phaser.Game(config);
}

startGame(config);
